import { post } from '~/plugins/nikan-api'
import Endpoints from '@nikan/endpoints'

const KEYS = {
  SetFormItems: 'setFormItems',
  AddItemToForm: 'addItemToForm',
  DeleteFormItem: 'deleteFormItem',
}
const state = {
  forms: []
}

export const mutations = {
  [KEYS.SetFormItems](state, data) {
    state.forms[data.form] = data.items
  },
  [KEYS.AddItemToForm](state, params) {
    const { form, newItem } = params
    let index = state.forms[form].findIndex(x => x.id === newItem.id)
    if (index > -1) {
      state.forms[form][index] = newItem
    }
    else {
      state.forms[form].push(newItem)
    }
  },
  [KEYS.DeleteFormItem](state, params) {
    const { form, printId } = params
    state.forms[form] = state.forms[form].filter(x => x.id !== printId)
  },
}

export const actions = {
  async getByForm({ dispatch, commit, state }, options) {
    options.force = !!options.force
    if (state.forms[options.form] && !options.force) {
      return state.forms[options.form]
    }
    var result = await post(Endpoints.getUrl('print.list'), { form: options.form }, null, { preventConcurrent: false })
    if (result.success) {
      commit(KEYS.SetFormItems, { form: options.form, items: result.data.items })
    }
    return state.forms[options.form]
  },
  async getPrintById({ dispatch, commit, state }, params) {
    const { printId, form } = params
    if (state.forms[form])
      var foundPrint = state.forms[form].find(x => x.id === printId)
    // else {
    //    dispatch('getByForm')({form,force:true})
    // }

    if (foundPrint && foundPrint.options)
      return foundPrint
    else {
      var result = await post(Endpoints.getUrl('print.get'), { id: printId }, null, { preventConcurrent: false })
      if (result.success) {
        const printData = result.data

        if (foundPrint) {
          printData.canDelete = foundPrint.canDelete
          printData.canEdit = foundPrint.canEdit
        }

        commit(KEYS.AddItemToForm, { ...params, newItem: printData })

        return result.data
      }
    }
  },
  deletePrintItem({ dispatch, commit, state }, params) {

    commit(KEYS.DeleteFormItem, params)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
